import type { FC } from 'react';
import { ListEndorsementsButton } from '@ContractBuilder/contract-builder-header/modules/endorsements-button/views/ListEndorsementsButton';
import type { EntityData } from '@domain/types/entity';
import { useEndorsementData } from '@queries/fetchEndorsements';

interface EndorsementsButtonControllerProps {
  submission: EntityData;
}

export const EndorsementsButtonController: FC<EndorsementsButtonControllerProps> = ({ submission }) => {
  const { data, isFetching } = useEndorsementData();

  return <ListEndorsementsButton data={data} isLoading={isFetching && !data} submission={submission} />;
};
